import { SetNewPasswordFormValues } from './types';

export const setNewPasswordDataKeys: { [K in keyof SetNewPasswordFormValues]: K } = {
    newPassword: 'newPassword',
    confirmNewPassword: 'confirmNewPassword',
};
